<template>
  <div>
    <div
      class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
      :class="!buyerSpace ? 'is-border-top has-background-white is-border-left is-border-right ' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
          <div
            data-tooltip="Contact(s) non valide"
            :class="{'tooltip is-tooltip-right' : !validBuyers}">
            <input
              id="buyerSpace"
              @change="$emit('updateBuyerSpaceId')"
              v-model="buyerSpace"
              name="buyerSpace"
              :disabled="!validBuyers"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="buyerSpace"
              :class="!buyerSpace ? '' : 'has-text-white'"
              style=""
              class="is-6 is-uppercase">
              <span v-if="!buyerSpace">ACTIVER L’ESPACE ACQUÉREUR SUR CE DOSSIER</span>
              <span
                v-else
                v-helper.right="'2QAgCWSkUyl10UDMZTofds'">ESPACE ACQUÉREUR ACTIVÉ SUR CE DOSSIER&nbsp;&nbsp;<i class="fal fa-info-circle"></i></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="buyerSpaceBuyers.length"
      class="is-padding-left is-padding-right is-padding-top">
      <div class="title is-5 is-uppercase is-margin-bottom-small">
        <b>CONNEXIONS À L’ESPACE ACQUÉREUR</b>
      </div>
      <div
        v-for="buyer in buyerSpaceBuyers"
        :key="buyer.pk"
        class="is-padding-bottom-xsmall">
        <b>{{ buyer.first_name }} {{ buyer.last_name }}</b>
        <span
          v-if="buyer.last_login_at"
          class="has-text-success is-padding-left-xsmall">
          <i class="fas fa-circle is-size-7"></i>
          Connecté {{ buyer.last_login_at | timeDelta }}
        </span>
        <span
          v-else
          class="has-text-grey is-padding-left-xsmall">
          <i class="fal fa-circle is-size-7"></i>
          Jamais connecté
        </span>
      </div>
    </div>
    <div class="is-padding">
      <div class="has-background-white is-padding-bottom">
        <div class="title is-5 is-uppercase">
          <b>MESSAGE D’INVITATION</b>
          <span
            class="is-padding-left-xsmall"
            v-helper.bottom="'3zbYTsVmhVuzDWHE5NwisM'">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
      </div>
      <div class="has-background-white">
        <wysiwyg-editor
          :light="true"
          :tooltip-top="true"
          :model="message"
          @change="val => message = val"
          class="editr--bottom-toolbar no-toolbar editr--height-small content">
        </wysiwyg-editor>
      </div>
      <div>
        <a
          @click="sendInvitation()"
          type="button"
          class="button is-success is-margin-top is-minW280p">
          ENVOYER L’INVITATION
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvBuyerSpaceInvitation',
  props: {
    has_buyer_space: {
      type: Boolean
    },
    validBuyers: {
      type: Boolean
    },
    advPk: {
      type: String
    },
    program: {
      type: Object
    },
    buyers: {
      type: Array
    },
    // dernier message envoyé (adv.buyer_space_invitation_message), sinon message par défaut
    invitationMessage: {
      type: String,
      default: null
    },
    // acquéreurs côté buyer-space avec leur dernière connexion
    buyerSpaceBuyers: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      buyerSpace: this.has_buyer_space,
      message: ''
    }
  },
  created () {
    if (this.invitationMessage) {
      this.message = this.invitationMessage
    } else {
      this.initMessage()
    }
  },
  methods: {
    initMessage () {
      let intro
      if (this.buyers.length > 1) {
        intro = `<p>Bonjour,</p>`
      } else {
        let genre = this.buyers[0].title === 'mme' ? 'Madame' : 'Monsieur'
        intro = `<p>Bonjour ${genre} ${this.buyers[0].last_name},</p>`
      }
      this.message = intro + `<p>Nous venons d’ouvrir votre espace acquéreur ${this.program.promoteur_data.company_name}.</p>
                <div>Vous pouvez y accéder à cette adresse <a href="${this.$configs.BUYER_SPACE_URL}?promoteur_pk=${this.program.promoteur.pk}">${this.$configs.BUYER_SPACE_URL}?promoteur_pk=${this.program.promoteur.pk}</a></div>
                <p>Vous devez finaliser l’activation en vous connectant. Pour cela vous allez devoir définir un mot de passe, vous permettant un accès sécurisé à l’ensemble des données.</p>
                <p>Dans cet espace vous pouvez :<ul><li>Retrouver toutes les informations sur le programme ${this.program.name}, mais aussi les données et le plan de votre logement</li><li>Télécharger les documents liés à votre acquisition (Contrat de réservations, appels de fonds…)</li></ul></p>
                <p>Un fil d’actualité vous permettra de rester informé de toutes les étapes d’avancement, avec des photos et documents spécifiques à votre logement.</p><p>Enfin, les coordonnées des contacts à votre disposition. Je reste votre contact référent et suis à votre disposition pour répondre à toutes vos questions</p><br>`
      if ('contacts' in this.program.buyer_space_data && this.program.buyer_space_data.contacts.length) {
        for (let contact of this.program.buyer_space_data.contacts) {
          if (contact.last_name && contact.first_name && contact.phone && contact.email && contact.role) {
            let digits = contact.phone.toString().match(/\d/ig)
            let phone
            if (digits) {
              phone = digits.map((e, i) => i % 2 ? e : ` ${e}`).join('')
            } else {
              phone = contact.phone
            }
            this.message = this.message + `<b>${contact.last_name} ${contact.first_name}</b><p>${contact.role}</p><p>Mail: <a href="mailto:${contact.email}">${contact.email}</a></p> <p>Téléphone: ${phone}</p>`
          }
        }
      }
    },
    async sendInvitation () {
      try {
        let payload = {
          message: this.message
        }
        await this.$api.post(`/reservations/${this.advPk}/buyer-space-activation`, payload)
        this.$emit('invitationSent', this.message)
        this.$toasted.global.success('Invitation envoyée')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
